import { Pipe, PipeTransform } from '@angular/core';
import { DprActivityInlineCustomDataReport } from '@report/models';
import {
  ActivityStream,
  ActivityStreamInlineCustomData,
  CustomData,
} from '@shared/models/project-setup';

@Pipe({
  name: 'inlineCustomDataColumns',
})
export class InlineCustomDataColumnsPipe implements PipeTransform {
  transform(
    activityStream: ActivityStream,
    activityStreamInlineCustomDataList: ActivityStreamInlineCustomData[],
    customDataList: CustomData[]
  ): DprActivityInlineCustomDataReport[] {
    const activityStreamsInlineCustomDataIds = (
      activityStreamInlineCustomDataList ?? []
    )
      .filter((as) => as.activityStreamId === activityStream.id)
      .map((a) => a.customDataId);

    return customDataList.reduce((acc, curr) => {
      if (activityStreamsInlineCustomDataIds.includes(curr.id)) {
        acc.push({
          id: curr.id,
          name: curr.name,
        });
      }
      return acc;
    }, []);
  }
}
